import React, { useState } from 'react';
import '../assets/css/style.css';

const TableViewComponent = ({ data }) => {
  console.log('jsonData >>>', data);
  let jsonObj = {};
  if(data){
    jsonObj = data[0];
  }

  // jsonObj =  {
  //   provider_name : "Dream Gaming",
  //   round_id : 123654,
  //   game_name : "Live Casino Lobby",
  //   table_code : 1,
  //   total_bet : 4000,
  //   total_win : 0,
  //   round_details : [
  //     {
  //       txn_id : -548454545,
  //       play_type : 'data',
  //       bet : 4000,
  //       win : 0,
  //       result : "Lose",
  //     }
  //   ],
  //   result_details : {
  //     type : "Other",
  //     // image_list : [{"Player" : ["https://opengameart.org/sites/default/files/styles/medium/public/king_of_hearts2.png", "https://opengameart.org/sites/default/files/styles/medium/public/queen_of_diamonds2.png"]},{"Bankar" : ["https://opengameart.org/sites/default/files/styles/medium/public/7_of_clubs.png", "https://opengameart.org/sites/default/files/styles/medium/public/7_of_clubs.png"]}]
  //     image_list : ["https://opengameart.org/sites/default/files/styles/medium/public/king_of_hearts2.png", "https://opengameart.org/sites/default/files/styles/medium/public/queen_of_diamonds2.png","https://opengameart.org/sites/default/files/styles/medium/public/7_of_clubs.png"]
  //   }
  // }
  // Extract column headers from object keys


  if(!Object.keys(jsonObj).length) return <></>
  return (
    <div style={tableContainerStyle}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th colSpan="2" style={thStyle}>Game Information</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={tdStyle}>Provider Name</td><td style={tdStyle}>{jsonObj.provider_name}</td></tr>
          <tr><td style={tdStyle}>Round ID</td><td style={tdStyle}>{jsonObj.round_id}</td></tr>
          <tr><td style={tdStyle}>Game Name</td><td style={tdStyle}>{jsonObj.game_name}</td></tr>
          <tr><td style={tdStyle}>Table No</td><td style={tdStyle}>{jsonObj.table_code}</td></tr>
        </tbody>
      </table>
      
      <table style={tableStyle}>
        <thead>
          <tr>
            <th colSpan="5" style={thStyle}>Round Details</th>
          </tr>
          <tr>
            <th style={thStyle}>Txn ID</th>
            <th style={thStyle}>Bet placed</th>
            <th style={thStyle}>Bet</th>
            <th style={thStyle}>Win</th>
            <th style={thStyle}>Result</th>
          </tr>
        </thead>
        <tbody>
          {jsonObj.round_details.map((detail, index) => (
            <tr key={index}>
              <td style={tdStyle}>{detail.txn_id}</td>
              <td style={tdStyle}>{detail.play_type}</td>
              <td style={tdStyle}>{detail.bet}</td>
              <td style={tdStyle}>{detail.win}</td>
              <td style={tdStyle}>{detail.result}</td>
            </tr>
          ))}
        </tbody>
      </table>
        {jsonObj.result_details.type === "Card" || jsonObj.result_details.type === "Dice" ? (
        <table style={tableStyle}>
          <thead>
            <tr>
              <th colSpan="3" style={thStyle}>Result Details</th>
            </tr>
          </thead>
          <tbody>
            {jsonObj.result_details.type === "Card"
              ? jsonObj.result_details.image_list.map((entry, index) => (
                  Object.entries(entry).map(([key, value]) => (
                    <tr key={`${index}-${key}`}>
                      <td style={tdStyle}>{key}</td>
                      <td style={tdStyle} colSpan={2}>{value.map((img, i) => (<img key={i} src={img} alt={key} style={imageStyle} />))}</td>
                    </tr>
                  ))
                )) : (
                  <tr>
                    {jsonObj.result_details.image_list.map((img, index) => (
                      <td key={index} style={tdStyle}>
                        <img src={img} alt="Dice" style={imageStyle} />
                      </td>
                    ))}
                  </tr>
                )}
          </tbody>
        </table>
      ) : null}        
    </div>
  );
};

const tableContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  padding: '20px',
};

const tableStyle = {
  width: '80%',
  borderCollapse: 'collapse',
  marginBottom: '20px',
};

const thStyle = {
  backgroundColor: 'grey',
  color: 'black',
  padding: '10px',
  border: '1px solid #ddd',
  textAlign: 'center',
};

const tdStyle = {
  padding: '10px',
  border: '1px solid #ddd',
  textAlign: 'center',
};

const imageStyle = {
  width: '100px'
}
export default TableViewComponent;
